import React, { useEffect, useState } from "react";
import SEO from '../Component/SEO';
import "./Product.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Gfooter from "../Component/Gfooter";

function ProductDetail(props) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [SubCardData, setSubCardData] = useState([]);
  const [mainCardName, setMainCardName] = useState("");
  const params = useParams();
  const mainId = props.mainId || params.mainId;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSubCards = async () => {
      try {
        const formData = new FormData();
        formData.append("main_id", mainId);

        const response = await axios.post(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_sub_cards",
          formData
        );

        if (response.data.status === true && response.data.data) {
          // Filter sub cards by main_id
          const filteredData = response.data.data.filter(
            (card) => card.main_id === mainId
          );
          setSubCardData(filteredData);
        }
      } catch (error) {
        console.error("Error fetching sub card data:", error);
      }
    };

    const fetchMainCard = async () => {
      try {
        const formData = new FormData();
        formData.append("main_id", mainId);

        const response = await axios.post(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_by_id_main_card",
          formData
        );

        if (response.data.status === true && response.data.data) {
          setMainCardName(response.data.data.name);
        }
      } catch (error) {
        console.error("Error fetching main card data:", error);
      }
    };

    fetchSubCards();
    fetchMainCard();
  }, [mainId]);

  const openImage = (src) => setSelectedImage(src);
  const closeImage = () => setSelectedImage(null);

  return (
    <>
      <SEO
        title="Facade Solutions & Metal Ceiling Systems | NLF Solutions"
        description="Explore architectural facade solutions and metal ceiling systems by NLF Solutions for modern commercial buildings, offices and interior spaces."
        canonical="https://nlfs.in/facade-solutions-metal-ceiling"
        keywords="Metal Ceiling Solutions, Facade Solutions, Metal Ceiling Systems, Architectural Metal Ceiling, Metal False Ceiling, Aluminium Ceiling, Architectural Facade Solutions, Building Facade Solutions, Facade Systems, Commercial Facade Solutions, Exterior Facade Solutions, Architectural Ceiling Solutions, metal ceiling solutions in India, architectural metal ceiling in India, commercial metal ceiling systems, metal false ceiling solutions for offices, architectural facade solutions in India, commercial building facade solutions, modern facade systems in India, facade and metal ceiling solutions, facade and ceiling solutions for commercial buildings"
      />
      <h1 className="seo-h1">Facade Solutions & Metal Ceiling Systems</h1>
      <section className="product-section mb-0 bg-white" style={{ backgroundColor: "#f0f0f0", marginTop: "100px" }}>
        <div className="container">
          {/* Breadcrumb / Back Button */}
          <div className="row mb-4">
            <div className="col-12">
              {/* <Link to="/product" className="btn btn-secondary mb-3">
              <i className="fa-solid fa-arrow-left me-2"></i>
              Back to Products
            </Link> */}
              <button
                onClick={() => navigate(-1)}
                className="btn  shadow-sm"
                style={{
                  position: "absolute",
                  left: "20px",
                  top: "20px",
                  zIndex: 1000,
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "50px"
                }}
              >
                ←
              </button>
              {mainCardName && (
                <h1 className="text-center mt-3" style={{ fontSize: '2rem' }}>{mainCardName}</h1>
              )}
            </div>
          </div>

          <div className="row">
            {SubCardData.length > 0 ? (
              SubCardData.map((product, index) => (
                <div
                  className="col-lg-3 col-md-6 col-sm-6 col-xs-12 article_padding card-sec"
                  key={index}
                >
                  <div className="offer_boxcontent">
                    <div className="upper_portion">
                      <div
                        className="article_img"
                        onClick={() =>
                          openImage(`https://cyberathon.com/NLF/${product.image}`)
                        }
                      >
                        <figure className="mb-0">
                          <img
                            src={`https://cyberathon.com/NLF/${product.image}`}
                            className="clickable-img"
                            alt={product.heading}
                          />
                        </figure>
                      </div>
                    </div>
                    <div className="lower_portion_wrapper">
                      <div className="lower_portion">
                        <h4 className="mb-0">{product.heading}</h4>
                      </div>

                      {/* Link to view individual sub card detail */}
                      <Link
                        className="read_more text-white text-decoration-none"
                        to={`/Subcarddetails/${product.sub_id}`}
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <p className="text-muted">No products available in this category.</p>
              </div>
            )}
          </div>
        </div>

        {/* Modal / Lightbox */}
        {selectedImage && (
          <div className="image-modal" onClick={closeImage}>
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={selectedImage} alt="Expanded" className="expanded-img" />
            </div>
          </div>
        )}
        <Gfooter />
      </section>
    </>
  );
}

export default ProductDetail;